import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Building2 } from 'lucide-react';
import { SERVICES } from '../data/services';

const ALL = [
  ...SERVICES.map((s) => ({ path: s.path, nav: s.nav, desc: s.heroIntro })),
  {
    path: '/renovation-energetique',
    nav: 'Rénovation énergétique',
    desc: 'Isolation, ventilation et menuiseries — y compris solutions biosourcées — pour améliorer le confort et la performance.',
  },
];

const ServicesLinks = () => {
  return (
    <section id="prestations" className="py-20 bg-white scroll-mt-28" data-testid="services-links">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-12">
          <div className="inline-flex items-center gap-2 text-emerald-700 font-medium mb-3">
            <Building2 className="h-5 w-5" /> Nos prestations
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Des travaux de rénovation du sol au toit
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Façade, isolation, tous corps d’état, étanchéité et couverture : découvrez nos prestations à
            Paris et en Île-de-France.
          </p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ALL.map((s) => (
            <Link
              key={s.path}
              to={s.path}
              data-testid={`home-service-${s.path}`}
              className="group bg-white border border-slate-200 rounded-2xl p-6 hover:border-emerald-500 hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-emerald-700 transition-colors">
                {s.nav}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed line-clamp-4 flex-1">{s.desc}</p>
              <span className="inline-flex items-center gap-2 text-emerald-700 font-medium text-sm mt-4 group-hover:gap-3 transition-all">
                En savoir plus <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesLinks;
